export const LOGIN_USER = "/admin/login";
export const FORGET_PASSWORD = "/admin/forgot";
export const UPDATE_ADMIN = "/admin/edit";
export const VERIFY_OTP = "/admin/verify_otp";
export const SET_PASSWORD = "/admin/set_password";
export const VIEW_USER = "/admin/view";
export const RESET_PASSWORD = "/admin/changePassword/";
export const CHANGE_PASSWORD = "/admin/change_password";
// File
export const POST_FILE = "/admin/upload";
export const POST_REMOVE_FILE = "/settings/remove";
//pages
export const CONTENTPAGES = "/admin/pages";
export const ADD_PAGES = "/admin/pages";
export const DELETE_PAGES = "/admin/pages/";
export const EDIT_PAGE = "/admin/pages/";
// users
export const USER_LIST = "/admin/user/list";
export const UPDATE_USER = "/admin/user/update_status/";
export const ADD_USER = "/admin/user/add";
export const USER_VIEW = "/admin/user/profile";
export const USER_PRIVATE_CHARACTER = "/admin/user/characters/";
export const USER_SUBSCRIPTION = "/subscription";
export const USER_TOKEN = "/transactions/token_history";
// profile     views
export const PROFILE_VIEWS = "/admin/profile";
// settings
export const SETTING_VIEW = "/admin/setting";
export const EDIT_SETTING = "/admin/setting/";
// get appearance
export const GET_APPEARANCE = "/users/character_appearances";
// token packages
export const TOKEN_PACKAGES = "/token_packs";
export const ADD_TOKEN_PACKAGE = "/token_packs/add";
export const EDIT_TOKEN_PACKAGE = "/token_packs/";
export const DELETE_TOKEN_PACKAGE = "/token_packs/";
export const DETAIL_TOKEN_PACKAGE = "/token_packs/";
// Charcter settings
export const CHARACTER_SETTING = "/admin/avatar_setting";
export const ADD_CHARACTER = "/admin/avatar_setting";
export const EDIT_CHARACTER = "/admin/avatar_setting/";
export const DELETE_CHARACTER = "/admin/avatar_setting/";

// dashboard data
export const GET_DASHBOARD_DATA = "/admin/dashboard";
export const GET_REVENUE = "/admin/dashboard/revenue";
export const GET_CHARACTER_REVENUE = "/admin/dashboard/characters_graph";
// user revneue
export const USER_REVENUE_LIST = "/admin/user/revenue";
export const USER_TRANSACTION = "/admin/revenue_trasactions";
export const USER_CHARACTER_REVENUE = "/admin/character_revenue";
export const REVENUE_DOWNLOAD = "/admin/user/revenue";
export const PAID_REVENUE_DOWNLOAD = "/admin/revenue_transfer";
// payments wise routes
export const TOKENREVEUNE = "/admin/payments";
export const IMAGESTOKEN = "/admin/characters";
// character list  type wise

export const CHARACTER_LIST = "/admin/agents";
export const DELETE_CHARACTER_LIST = "/admin/agent/";
export const VIEW_CHARACTER = "/admin/agent/";
export const CREATE_PERSONAL_CHARACTER = "/users/characters/add";
// userlist download
export const USER_LIST_DOWNLOAD = "/admin/user";
export const DOWNLOAD_TRANSACTION_LIST = "/admin/payments";
// Langauge
export const LANGUAGE_LIST = "/admin/language";
export const ADD_LANGUAGE = "/admin/language";
export const EDIT_LANGUAGE = "/admin/language/";
export const DELETE_LANGUAGE = "/admin/language/";
export const ALL_LANGUAGE = "/admin/all_languages";
// SUBSCRIPTION
export const SUBSCRIPTION_LIST = "/plans";
export const SUBSCRIPTION_ADD = "/plans/add";
export const SUBSCRIPTION_DETAIL = "/plans";
export const EDIT_SUBSCRIPTION = "/plans/";
export const DELETE_SUBSCRIPTION = "/plans/";
// transaction manage
export const TRANSACTION_LIST = "/admin/payments";

export const HOME_CONTENT = "/admin/contents/list";
export const ADD_HOME = "/admin/contents";
export const EDIT_CONTENT = "/admin/contents/";
export const DELETE_CONTENT = "/admin/contents/";
export const VIEW_HOME = "/admin/contents/";

// character style
export const GET_CHARACTER_STYLE = "/users/character_style";

// Create avtar
export const AGENT_TRAITS = "users/agent-traits";
export const CREATE_AGENT = "admin/create-agent";

// Get audio
export const GET_AUDIOS = "users/voice-library/";

export const SUBSCRIPTION_REVENUE_LIST = "/subscription";
export const TRANSACTION_REVENUE_LIST = "/transactions";


// REQUESTS
export const REQUESTS_LIST = "/contactus/list";
export const DELETE_REQUEST = "/contactus/";
export const UPDATE_REQUEST = "/contactus/";


